import { Box, Dialog, DialogContent, DialogTitle, IconButton, styled, Typography } from "@material-ui/core";
import { closeIcon, profileAvatar } from "../../../../blocks/call-recording/src/assets";
import ImageRenderer from "../../../../components/src/ImageRenderer.web";
import React from "react";
import { verifyImg } from "../../../../components/src/utils";
import { ownerShipIcon } from "../../../../blocks/chat/src/assets";
import { icAccept, icTrashRed } from "../../../../blocks/groups/src/assets";

export type TActionMemberRequest = "accept" | "reject";

export interface IListMemberRequest {
    id: number,
    group_uid: string,
    status: string,
    created_at: string,
    account: {
        data: {
            attributes: {
                id: number;
                full_name: string;
                user_name: string;
                profile_photo: string;
                user_subscription: string;
                user_ownership: boolean;
            }
        }
    }
}

interface IPropListMemberRequest {
    listMemberRequest: IListMemberRequest[];
    isOpen: boolean;
    toggleModal: () => void;
    onActionMemberRequest?: (action: TActionMemberRequest,memberRequestId: number) => Promise<void>;
}

export default function ListMemberRequest(props: IPropListMemberRequest) {
    return <ListMemberRequestStyled
        id="requestSubscribeGroupModal"
        open={props.isOpen}
        onClose={props.toggleModal}
        PaperProps={{
            style: {
                background: "#0B0B0B",
                border: "1px solid #35383F",
                padding: 20,
                paddingTop: 4,
                borderRadius: 10,
                width: "653px",
                height: 533,
                boxSizing: "border-box",
                gap: 16,
                alignItems: "center",
            }
        }}>

        <Box className="headerDialog">
            <DialogTitle>
                Member requests
            </DialogTitle>
            <IconButton className="btnCloseDialog" onClick={props.toggleModal}>
                <ImageRenderer src={closeIcon} width={24} height={24} />
            </IconButton>
        </Box>
        <DialogContent className="dialogContent">
            <Box className="listHeader">
                <Box className="col_1">
                    <Typography>
                        Name
                    </Typography>
                </Box>
                <Box className="col_2">
                    <Typography>
                        Date
                    </Typography>
                </Box>
                <Box className="col_3">
                    <Typography>
                        Action
                    </Typography>
                </Box>
            </Box>
            <Box className="listItem">
                {props.listMemberRequest.map(memberRequest => {
                    const { attributes } = memberRequest.account.data;
                    return <Box className="rowItem">
                        <Box className="col_1">
                            <Box className="profileAvatarItem">
                                <ImageRenderer src={attributes.profile_photo} borderRadius="50px" width={44} height={44} style={{ borderRadius: "50px", border: "1px dashed #F0E5FF" }} />
                            </Box>
                            <Box className="profileInformation">
                                <Box className="profileName">
                                    <Typography>
                                        {attributes.full_name}
                                    </Typography>
                                    <Box className="messageInformation__infoBadge">
                                        <Box>
                                            <img alt="i" src={verifyImg(attributes.user_subscription)} width={14} height={14} />
                                        </Box>
                                        <Box>
                                            {attributes.user_ownership && <img alt="i" src={ownerShipIcon} width={14} height={14} />}
                                        </Box>
                                    </Box>
                                </Box>
                                <Box className="profileUserName">
                                    <Typography>
                                        {attributes.user_name}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box className="col_2">
                            <Typography>
                                25 Jan 2025
                            </Typography>
                        </Box>
                        <Box className="col_3 listAction">
                            <IconButton className="btnAction" onClick={() => props.onActionMemberRequest && props.onActionMemberRequest("accept", memberRequest.id)} >
                                <ImageRenderer src={icAccept} width={32} height={32} />
                            </IconButton>
                            <IconButton className="btnAction" onClick={() => props.onActionMemberRequest && props.onActionMemberRequest("reject", memberRequest.id)} >
                                <ImageRenderer src={icTrashRed} width={32} height={32} />
                            </IconButton>
                        </Box>
                    </Box>
                })}
            </Box>
        </DialogContent>
    </ListMemberRequestStyled>
}

const ListMemberRequestStyled = styled(Dialog)(() => ({
    "& .headerDialog": {
        position: "relative",
        width: "100%",
        textAlign: "center",
        borderBottom: "1px solid #222",
        "& .MuiDialogTitle-root": {
            padding: "20px 0",
            "& h2": {
                fontFamily: "Manrope",
                fontWeight: 800,
                fontSize: 18,
                color: "#FFF",
                lineHeight: "24px",
            }
        },
        "& .btnCloseDialog": {
            position: "absolute",
            top: 8,
            right: -8,
        }
    },
    "& .dialogContent": {
        display: "flex",
        flexDirection: "column",
        gap: 16,
        width: "100%",
        boxSizing: "border-box",
        padding: 0,
        "& .listHeader": {
            padding: 8,
            display: "flex",
            "& .col_1": {
                flex: "0 0 calc(100% / 12 * 6)",
                maxWidth: "calc(100% / 12 * 6)"
            },
            "& .col_2": {
                flex: "0 0 calc(100% / 12 * 4)",
                maxWidth: "calc(100% / 12 * 4)"
            },
            "& .col_3": {
                flex: "0 0 calc(100% / 12 * 2)",
                maxWidth: "calc(100% / 12 * 2)"
            },
            "& .col_1,.col_2,.col_3": {
                "& p": {
                    fontFamily: "Manrope",
                    fontWeight: 500,
                    fontSize: 12,
                    color: "#999",
                    textAlign: "center",
                }
            }
        },
        "& .listItem": {
            display: "flex",
            flexDirection: "column",
            gap: 16,
            "& .rowItem": {
                paddingBottom: 4,
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #222",
                "& .col_1": {
                    flex: "0 0 calc(100% / 12 * 6)",
                    maxWidth: "calc(100% / 12 * 6)",
                    display: "flex",
                    gap: 10,
                    "& .profileInformation": {
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        "& .profileName": {
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            "& p": {
                                fontFamily: "Manrope",
                                fontWeight: 600,
                                fontSize: 16,
                                color: "#FFF"
                            },
                            "& .messageInformation__infoBadge": {
                                display: "flex",
                                gap: 2,
                                alignItems: "center"
                            }
                        },
                        "& .profileUserName": {
                            "& p": {
                                fontFamily: "Manrope",
                                fontWeight: 500,
                                fontSize: 10,
                                color: "#E0E0E0"
                            }
                        }
                    }
                },
                "& .col_2": {
                    flex: "0 0 calc(100% / 12 * 4)",
                    maxWidth: "calc(100% / 12 * 4)",
                    "& p": {
                        textAlign: "center",
                        fontFamily: "Manrope",
                        fontWeight: 500,
                        fontSize: 12,
                        color: "#FFF",
                    }
                },
                "& .col_3.listAction": {
                    flex: "0 0 calc(100% / 12 * 2)",
                    maxWidth: "calc(100% / 12 * 2)",
                    display: "flex",
                    gap: 12,
                    "& .btnAction": {
                        width: 32,
                        height: 32,
                    }
                },
            }
        }
    }
}))